import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText,
  TextField, Box, Select, MenuItem, FormControl, InputLabel
} from '@mui/material';
import sendRequest from '../utils/sendRequest';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { MenuButtonIcon, SubmitButton, CancelButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function AddTrackingDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails, delivDate, fetchPos=null, isIcon=false }) {
  const [open, setOpen] = useState(false);
  const [loadingTracking, setLoadingTracking] = useState(false);
  const [trackingNumber, setTrackingNumber] = useState("");
  const [carrier, setCarrier] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [carrierSelect, setCarrierSelect] = useState("");

  const handleOpen = () => {
    setTrackingNumber("");
    setCarrier("");
    setDeliveryDate(isIcon ? '' : delivDate);
    setCarrierSelect("");
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingTracking) {
        setOpen(false);
    }
  };

  const addTracking = async () => {
    setLoadingTracking(true);
    try {
        let body = {
            tracking_number: trackingNumber,
            carrier: carrier,
            delivery_date: JSON.stringify(deliveryDate)
        }
        let response = await sendRequest(
            `purchase-orders/add-tracking?po_doc_id=${po_doc_id}`, body, "POST"
        );
        addSnackbar(response.message);
        handleClose();
        isIcon ? fetchPos() : fetchPoDetails();
    } catch (error) {
        addSnackbar(error.message, false);
    } finally {
        setLoadingTracking(false);
    }
  }

  const handleTrackingNumberChange = (e) => {
    let value = e.target.value;
    if (value) {
      setTrackingNumber(value);
    } else {
      setTrackingNumber("");
    }
  }

  const handleCarrierChange = (e) => {
    const value = e.target.value;
    setCarrierSelect(value);
    if (value && value !== "Other") {
      setCarrier(value);
    } else {
      setCarrier("");
    }
  }

  const handleDeliveryDateChange = (e) => {
    let value = e.target.value;
    if (value) {
      setDeliveryDate(value);
    } else {
      setDeliveryDate("");
    }
  }

  return (
    <Box>
      <MenuButtonIcon
        isIcon={isIcon}
        title={"Add Tracking"}
        text={"Add Tracking Details"}
        icon={LocalShippingIcon}
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingTracking}
        PaperProps={{
          component: 'form',
          onSubmit: event => {
            event.preventDefault();
            addTracking();
          },
          autoComplete: 'off',
        }}
      >
        <CustomDialogTitle
          header={"Tracking Information"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>Please enter the tracking information.</DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="tracking_number"
            name="tracking_number"
            label="Tracking Number"
            type="text"
            fullWidth
            variant="standard"
            onChange={handleTrackingNumberChange}
          />
          <FormControl fullWidth variant="standard" margin="dense" required>
            <InputLabel id="carrier-label">Carrier</InputLabel>
            <Select
              labelId="carrier-label"
              id="carrier"
              value={carrierSelect}
              onChange={handleCarrierChange}
              label="Carrier"
            >
              <MenuItem value="UPS">Rapid Frieght Freight Express</MenuItem>
              <MenuItem value="FedEx">American International Transport</MenuItem>
              <MenuItem value="UPS">UPS</MenuItem>
              <MenuItem value="DHL">SPL Logistics</MenuItem>
              <MenuItem value="Innovative">Innovative Carriers</MenuItem>
              <MenuItem value="Customer">Customer Shipping</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>

          {carrierSelect === "Other" && (
            <TextField
              required
              margin="dense"
              id="custom_carrier"
              name="custom_carrier"
              label="Enter Carrier Name"
              type="text"
              fullWidth
              variant="standard"
              onChange={(e) => setCarrier(e.target.value)}
            />
          )}
          <TextField
            required
            margin="dense"
            id="delivery_date"
            name="delivery_date"
            label="Expected Delivery Date"
            type="date"
            fullWidth
            variant="standard"
            value={deliveryDate}
            onChange={handleDeliveryDateChange}
            InputLabelProps={{ shrink: true }}
          />
          <div></div>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingTracking}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingTracking}
            text={"Submit"}
            type="submit"
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}